import React from "react";
import { Typography, makeStyles, Grid } from "@material-ui/core";
import TestimonyCard from "../components/TestimonyCard";
import QuoteUp from "../components/QuoteUp";
import QuoteDown from "../components/QuoteDown";

const useStyles = makeStyles({
  section: {
    margin: "4vw 0px",
    textAlign: "center",
    padding: "64px 10vw",
    position: "relative",
  },
  title: {
    fontSize: 35,
    fontWeight: "bold",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "normal",
    letterSpacing: "normal",
    textAlign: "center",
  },
  quoteUp: {
    position: "absolute",
    top: 32,
    left: "10vw",
  },
  quoteDown: {
    position: "absolute",
    bottom: -64,
    right: "10vw",
  },
  ["@media (max-width: 720px)"]: {
    quoteUp: {
      top: -64,
    },
  },
});

export default function Benefits() {
  const classes = useStyles();
  const features = [
    {
      author: "سعید تیموریان مطلق",
      description:
        "It was a bit odd at first to try teaching online, but then it was is if it had been all wrong, and this is the only way you can make the most out of teaching now on Lingotalk ",
      avatar: "https://api.lingotalk.io/static/users/avatar/avatar_126_3.jpg",
    },
    {
      author: "مرتضی انصاری",

      description:
        "My biggest problem in teaching private classes was commute! After getting to know Lingotalk, I managed to save up hours of time and lots of energy for my teaching",
      avatar: "https://api.lingotalk.io/static/users/avatar/avatar_2_1.jpg",
    },
    {
      author: "مریم قربانی",

      description:
        "Have you ever felt like you are tired with teaching?! Trust me, we have all been there; it is time you tried a much better approach to your teaching carrier here at Lingotalk",
      avatar: "https://api.lingotalk.io/static/users/avatar/avatar_50_1.jpg",
    },
  ];
  return (
    <section>
      <section className={classes.section}>
        <Typography variant="h5" className={classes.title}>
          تجربه اساتید در لینگوتاک‬
        </Typography>
        <br /> <br /> <br />
        <Grid container spacing={4} justify="center">
          {features.map((feature, index) => (
            <Grid item xs={12} md={4} key={index}>
              <TestimonyCard {...feature} />
            </Grid>
          ))}
        </Grid>
        <QuoteUp className={classes.quoteUp} />
        <QuoteDown className={classes.quoteDown} />
      </section>
    </section>
  );
}
